import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import { updateBoardMember, deleteBoardMember } from '../../redux/actions/boardMemberActions';
import SpinnerV2 from '../Spinner/Spinner';
import BoardMemberForm from './BoardMemberForm';

const EditBoardMember = (props) => {
  let { boardMemberId } = useParams();
  const dispatch = useDispatch()
  const boardMembers = useSelector(state => state.boardMembers)
  const [boardMember, setBoardMember] = useState(undefined);
  const [isUpdating, setIsUpdating] = useState(false);
  const history = useHistory();
  
  const findBoardMember = () => {
    const ix = boardMembers.board_members.findIndex((bm) => {
      if (bm.id === Number(boardMemberId)) {
        return true;
      } else {
        return false;
      }
    })
    
    if (ix >= 0) {
      const tempBoardMember = {...boardMembers.board_members[ix], term_end_date: new Date(boardMembers.board_members[ix].term_end_date)}
      return tempBoardMember;
    }
    return undefined;
  }

  useEffect(() => {
    if (boardMember === undefined) {
      const bm = findBoardMember()
      if (bm !== undefined) {
        const endDate = new Date(bm.term_end_date)
        bm.term_end_date = endDate;
        setBoardMember(bm)
      }
    }
    if (isUpdating && boardMembers.updating === false) {
      setIsUpdating(false);
      history.replace(`/documents`)
    }
  }, [boardMembers.updating])

  const onEditBoardMember = (boardMember) => {
    setIsUpdating(true);
    dispatch(updateBoardMember(boardMember));    
  }

  const deleteBoardMemberConfirm = (boardMember) => {
    let areYouSure = window.confirm(`Are you sure you want to remove ${boardMember.name}?`);
    if (areYouSure) {
      setIsUpdating(true);
      dispatch(deleteBoardMember(boardMember.id))
      return true;
    }
    return false;
  }

  // TODO: CHANGE this to report an error if boardMember === undefined
  if (boardMembers.updating || boardMember === undefined || isUpdating) {
    return <SpinnerV2 title="Updating board member..." />
  }

  return (
    <div>
      <BoardMemberForm 
        title="Edit Board Member"
        edit={true} 
        boardMember={boardMember} 
        onSubmit={onEditBoardMember}
        onCancel={() => {history.replace(`/documents`)}}
        onDelete={() => {deleteBoardMemberConfirm(boardMember)}}
      />
    </div>
  );
}

export default EditBoardMember;